<benefits-dialog
  [open]="true"
  [heading]="(mode() === 'lost' ? 'ASSETS.CHARGE.TITLE_LOST' : 'ASSETS.CHARGE.TITLE_DAMAGED') | translate"
  [eyebrow]="'ASSETS.EYEBROW' | translate"
  (closed)="closed.emit()"
>
  <div class="asset-loss-dialog">
    @if (canCharge()) {
      @if (hasAssignee()) {
        <label class="field field--checkbox" for="asset-charge-toggle">
          <input id="asset-charge-toggle" type="checkbox" [checked]="chargeOn()" (change)="toggleCharge($any($event.target).checked)" />
          <span class="field__label">{{ 'ASSETS.CHARGE.TOGGLE' | translate }}</span>
        </label>

        @if (chargeOn()) {
          <fieldset class="asset-loss-dialog__fields">
            <p class="asset-loss-dialog__employee">
              <span class="field__label">{{ 'ASSETS.CHARGE.EMPLOYEE' | translate }}</span>
              <strong>{{ asset().assignedUserName || '-' }}</strong>
            </p>

            <label class="field" for="asset-charge-amount">
              <span class="field__label">{{ 'ASSETS.CHARGE.AMOUNT' | translate }}</span>
              <input id="asset-charge-amount" class="field__input" type="number" min="0" step="0.01" inputmode="decimal" [value]="amountText()" (input)="setAmount($any($event.target).value)" />
            </label>

            <div class="field" role="radiogroup" [attr.aria-label]="'ASSETS.CHARGE.PAYMENT' | translate">
              <span class="field__label">{{ 'ASSETS.CHARGE.PAYMENT' | translate }}</span>
              <label class="asset-loss-dialog__radio" for="asset-charge-pay-full">
                <input id="asset-charge-pay-full" type="radio" name="asset-charge-payment" [checked]="payment() === 'full'" (change)="setPayment('full')" />
                <span>{{ 'ASSETS.CHARGE.FULL' | translate }}</span>
              </label>
              <label class="asset-loss-dialog__radio" for="asset-charge-pay-installments">
                <input id="asset-charge-pay-installments" type="radio" name="asset-charge-payment" [checked]="payment() === 'installments'" (change)="setPayment('installments')" />
                <span>{{ 'ASSETS.CHARGE.INSTALLMENTS' | translate }}</span>
              </label>
            </div>

            @if (payment() === 'installments') {
              <label class="field" for="asset-charge-count">
                <span class="field__label">{{ 'ASSETS.CHARGE.COUNT' | translate }}</span>
                <input id="asset-charge-count" class="field__input" type="number" min="2" step="1" inputmode="numeric" [value]="countText()" (input)="setCount($any($event.target).value)" />
              </label>
            }

            <label class="field" for="asset-charge-start">
              <span class="field__label">{{ 'ASSETS.CHARGE.START' | translate }}</span>
              <input id="asset-charge-start" class="field__input" type="month" [value]="start()" (input)="start.set($any($event.target).value)" />
            </label>

            <label class="field" for="asset-charge-note">
              <span class="field__label">{{ 'ASSETS.CHARGE.NOTE' | translate }}</span>
              <input id="asset-charge-note" class="field__input" type="text" [value]="note()" (input)="note.set($any($event.target).value)" />
            </label>

            <app-asset-charge-preview [preview]="preview()" />
          </fieldset>
        }
      } @else {
        <p class="asset-loss-dialog__no-assignee">{{ 'ASSETS.CHARGE.NO_ASSIGNEE' | translate }}</p>
      }
    }
  </div>

  <ng-container benefitsDialogFooter>
    <button type="button" pButton [outlined]="true" [label]="'COMMON.CANCEL' | translate" (click)="closed.emit()"></button>
    <button type="button" pButton class="asset-loss-dialog__confirm" icon="pi pi-check" [label]="'COMMON.CONFIRM' | translate" [disabled]="!canConfirm()" (click)="confirm()"></button>
  </ng-container>
</benefits-dialog>
